import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, CreditCard, RefreshCw, LogOut } from 'lucide-react';

export default function ExpiredPage() {
  const navigate = useNavigate();
  const [barbershopId, setBarbershopId] = useState(null);
  const [barbershopSlug, setBarbershopSlug] = useState('');
  const [selectedPlan, setSelectedPlan] = useState('pro');

  useEffect(() => {
    const id = localStorage.getItem('barbershopId');
    if (!id) {
      navigate('/login');
      return;
    }
    setBarbershopId(id);
    setBarbershopSlug(localStorage.getItem('barbershopSlug') || '');
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('barbershopId');
    localStorage.removeItem('barbershopName');
    localStorage.removeItem('barbershopSlug');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center px-4">
      <div className="card p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-yellow-500/10 flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-yellow-400" />
        </div>

        <h1 className="text-2xl font-bold text-white mb-2">
          Plano Expirado
        </h1>

        <p className="text-gray-400 mb-6">
          Seu plano de assinatura expirou. Para continuar usando o sistema,
          renove sua assinatura.
        </p>

        <div className="bg-dark-700 rounded-xl p-4 mb-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <CreditCard className="w-5 h-5 text-primary-400" />
            <span className="text-sm text-gray-400">Usuário:</span>
            <span className="font-medium text-white">{barbershopSlug || '--'}</span>
          </div>
          <p className="text-sm text-gray-500">
            Renove pelo Pix e o dashboard volta automaticamente quando o pagamento for aprovado.
          </p>
        </div>

        <div className="space-y-3">
          <select value={selectedPlan} onChange={(e) => setSelectedPlan(e.target.value)} className="input text-left">
            <option value="basico">Basico - R$ 29,90/mes</option>
            <option value="pro">Pro - R$ 59,90/mes</option>
            <option value="premium">Premium - R$ 99,90/mes</option>
          </select>

          <button onClick={() => navigate(`/checkout/renew/${barbershopId}/${selectedPlan}`)} disabled={!barbershopId} className="btn-primary w-full">
            <RefreshCw className="w-5 h-5 mr-2" />
            Renovar agora
          </button>

          <button
            onClick={handleLogout}
            className="btn-ghost w-full"
          >
            <LogOut className="w-5 h-5 mr-2" />
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}
